<template lang="pug">
.match-bet-area-type
  //- span.text-black-50 {{ details }}
  .match-bet-area-type-title {{ betType == 'hdp' ? $tc("m.BT_HDPF", 2) : $tc("m.BT_HDPH", 2) }}
  .match-odd-area
    .match-odd-area-oddtype
      p.mb-0 {{ $t("m.ODD_Home") }}
      p.mb-0 {{ $t("m.ODD_Away") }}
    template(v-for="(dn, i) in details['tn']")
      .match-odd-area-group
        template(v-if="details[betType] && details[betType][i] && details[betType][i][9] != 0 && details[betType][i][10] != 0 && details[betType][i][9] != '' && details[betType][i][10] != ''")
          OddsItem(:odds="details[betType][i]" :idx="details[betType][i][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" :mode="betType" :count="i" :details="details" homeAway="1")
        template(v-else)
          OddsDisabled
        template(v-if="details[betType] && details[betType][i] && details[betType][i][9] != 0 && details[betType][i][10] != 0 && details[betType][i][9] != '' && details[betType][i][10] != ''")
          OddsItem(:odds="details[betType][i]" :idx="details[betType][i][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" :mode="betType" :count="i" :details="details" homeAway="2")
        template(v-else)
          OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  props: {
    details: {
      type: Object
    },
    oddsType: {
      type: String
    },
    i: {
      type: [String, Number]
    },
    betType: {
      type: String
    },
    homeAway: {
      type: String
    }
  }
};
</script>